import { Injectable, Inject } from '@angular/core';
import { IConfiguration } from '../Model/Interfaces/IConfiguration';
import { HttpClient } from '@angular/common/http';
/**
 * This Service is used to handle the Client Configuration
 *
 * @export
 * @class ConfigurationService
 */
@Injectable()
export class ConfigurationService {
  private readonly configUrlPath: string = 'ClientConfiguration';
  private configData?: IConfiguration;
  constructor(
    private readonly http: HttpClient,
    @Inject('BASE_URL') private readonly originUrl: string
  ) {}

  async loadConfigurationData(): Promise<IConfiguration> {
    this.configData = await this.http
      .get<IConfiguration>(`${this.originUrl}${this.configUrlPath}`)
      .toPromise();

    if (!this.configData) {
      throw new Error('Could not get config.');
    }
    return this.configData;
  }

  get config(): IConfiguration | undefined {
    return this.configData;
  }
}
